import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
  Box, Card, CardContent, Typography, Stack, Button, Chip, IconButton, Tooltip,
} from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import PersonAddAlt1RoundedIcon from '@mui/icons-material/PersonAddAlt1Rounded';
import { getBearerToken, postBearerToken, putBearerToken } from '../../utils/Apis';
import { useNavigate } from 'react-router-dom';
import AppShell from '../../layouts/AppShell';

const Sa_admin_list = () => {
    const navigate = useNavigate()
    const [rows, setrows] = React.useState([])
    const [rendered, setrendered] = useState(0)
    React.useEffect(() => {
        fetch_users()
    }, [rendered])


    const editAdmin = async (id, type) => {
        if (type == "E") {
            navigate("/edit_admin", { state: { id: id } })
        } else {
            putBearerToken("users?_id=" + id, { deleted_at: new Date() }).then((result) => {
                if (result.error == 0) {

                    setrendered(o => o + 1)

                } else {


                }

            })

        }

    }

    const fetch_users = async () => {
        getBearerToken("users?type=Admin").then((result) => {
            if (result.error == 0) {
                console.log(result.data)
                setrows(result.data)
            } else {
                // notify(JSON.stringify(result.messages))
            }
        })
    }


    const columns = [
        {
            field: 'first_name',
            headerName: 'First Name',
            flex: 1,
            minWidth: 130,
        },
        {
            field: 'phone',
            headerName: 'Phone',
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'slug_name',
            headerName: 'User Name',
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'show_password',
            headerName: 'Password',
            flex: 1,
            minWidth: 110,
        },
        {
            field: 'from_date',
            headerName: 'Start Date',
            flex: 1,
            minWidth: 120,
            valueGetter: (params) => params.row.from_date.split("T")[0]

        },
        {
            field: 'to_date',
            headerName: 'Expiry Date',
            flex: 1,
            minWidth: 120,
            valueGetter: (params) => params.row.to_date.split("T")[0]

        },
        {
            field: 'is_active',
            headerName: 'Status',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Chip size="small" label={params.row.is_active == true ? "Active" : "Inactive"}
                    color={params.row.is_active == true ? "success" : "error"} variant="outlined" />
            )
        },
        {
            field: 'action',
            headerName: 'Actions',
            flex: 1.4,
            minWidth: 160,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <Tooltip title="Edit">
                        <IconButton size="small" color="primary" onClick={() => editAdmin(params.row._id, "E")}><EditRoundedIcon fontSize="small" /></IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <IconButton size="small" color="error" onClick={() => editAdmin(params.row._id, "D")}><DeleteOutlineRoundedIcon fontSize="small" /></IconButton>
                    </Tooltip>
                </Stack>
            )
        },

    ];


    return (
        <AppShell title="Admin Management" breadcrumb={['Admins']}>
            <Card>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                    <Stack direction="row" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h4">Admins</Typography>
                        <Button sx={{ ml: 'auto' }} variant="contained" startIcon={<PersonAddAlt1RoundedIcon />} onClick={() => navigate('/create_admin')}>
                            Add Admin
                        </Button>
                    </Stack>

                    <Box sx={{ width: '100%' }}>
                        <DataGrid
                            autoHeight
                            rows={rows}
                            columns={columns}
                            getRowId={(data) => data._id}
                            disableRowSelectionOnClick
                            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                            pageSizeOptions={[10, 25, 50]}
                            sx={{ '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': { outline: 'none' } }}
                        />
                    </Box>
                </CardContent>
            </Card>
        </AppShell>
    )
}

export default Sa_admin_list
